export const styleManager = (project) => {
  const fontList = generateFontList(project);
  return {
    sectors: [
      {
        name: 'General',
        buildProps: ['display', 'position'],
        properties: [
          { property: 'position', type: 'select' },
          {
            property: 'display',
            type: 'select',
            list: [
              { value: 'block' },
              { value: 'inline' },
              { value: 'inline-block' },
              { value: 'inline-flex' },
              { value: 'inline-grid' },
              { value: 'inline-table' },
              { value: 'list-item' },
              { value: 'flex' },
              { value: 'grid' },
              { value: 'inherit' },
              { value: 'initial' },
              { value: 'revert' },
              { value: 'contents' },
              { value: 'table' },
              { value: 'table-caption' },
              { value: 'table-cell' },
              { value: 'table-row' },
              { value: 'table-column' },
              { value: 'none' },
            ],
          },
        ],
      },
      {
        name: 'Dimension',
        open: false,
        buildProps: [
          'width',
          'height',
          'min-width',
          'min-height',
          'max-width',
          'max-height',
          'margin',
          'padding',
        ],
        properties: [
          {
            id: 'min-width',
            type: 'integer',
            name: 'Min width',
            units: ['px', '%', 'vw', 'em', 'rem'],
            property: 'min-width',
            defaults: 'auto',
          },
          {
            id: 'max-height',
            type: 'integer',
            name: 'Max height',
            units: ['px', '%', 'vw', 'em', 'rem'],
            property: 'max-height',
            defaults: 'auto',
          },
          {
            property: 'margin',
            properties: [
              { name: 'Top', property: 'margin-top' },
              { name: 'Right', property: 'margin-right' },
              { name: 'Bottom', property: 'margin-bottom' },
              { name: 'Left', property: 'margin-left' },
            ],
          },
          {
            property: 'padding',
            properties: [
              { name: 'Top', property: 'padding-top' },
              { name: 'Right', property: 'padding-right' },
              { name: 'Bottom', property: 'padding-bottom' },
              { name: 'Left', property: 'padding-left' },
            ],
          },
        ],
      },
      {
        name: 'Typography',
        open: false,
        buildProps: [
          'font-family',
          'font-size',
          'font-weight',
          'letter-spacing',
          'font-style',
          'line-height',
          'color',
          'text-align',
          'text-decoration',
          // 'text-shadow',
        ],
        properties: [
          {
            name: 'Font',
            property: 'font-family',
            defaults: 'Default',
            list: fontList,
          },

          { name: 'Weight', property: 'font-weight' },
          {
            name: 'Font style',
            property: 'font-style',
            type: 'select',
            defaults: 'normal',
            list: [
              { value: 'inherit' },
              { value: 'initial' },
              { value: 'italic' },
              { value: 'normal' },
              { value: 'oblique' },
              { value: 'revert' },
              { value: 'unset' },
            ],
          },
          { name: 'Font color', property: 'color' },
          {
            property: 'text-align',
            type: 'radio',
            defaults: 'left',
            list: [
              { value: 'left', name: 'Left', className: 'fa fa-align-left' },
              { value: 'center', name: 'Center', className: 'fa fa-align-center' },
              { value: 'right', name: 'Right', className: 'fa fa-align-right' },
              { value: 'justify', name: 'Justify', className: 'fa fa-align-justify' },
            ],
          },
          {
            property: 'text-decoration',
            type: 'radio',
            defaults: 'none',
            list: [
              { value: 'none', name: 'None', className: 'fa fa-times' },
              { value: 'underline', name: 'underline', className: 'fa fa-underline' },
              {
                value: 'line-through',
                name: 'Line-through',
                className: 'fa fa-strikethrough',
              },
            ],
          },
          // {
          //   property: 'text-shadow',
          //   properties: [
          //     { name: 'X position', property: 'text-shadow-h' },
          //     { name: 'Y position', property: 'text-shadow-v' },
          //     { name: 'Blur', property: 'text-shadow-blur' },
          //     { name: 'Color', property: 'text-shadow-color' },
          //   ],
          // },
        ],
      },
      {
        name: 'Decorations',
        open: false,
        buildProps: [
          'opacity',
          // 'box-shadow',
          'background-bg',
          'background-color',
        ],
        properties: [
          {
            type: 'slider',
            property: 'opacity',
            defaults: 1,
            step: 0.01,
            max: 1,
            min: 0,
          },
          // {
          //   property: 'box-shadow',
          //   properties: [
          //     { name: 'X position', property: 'box-shadow-h' },
          //     { name: 'Y position', property: 'box-shadow-v' },
          //     { name: 'Blur', property: 'box-shadow-blur' },
          //     { name: 'Spread', property: 'box-shadow-spread' },
          //     { name: 'Shadow Color', property: 'box-shadow-color' },
          //     { name: 'Shadow type', property: 'box-shadow-type' },
          //     { name: 'Background Color', property: 'background-color' },
          //   ],
          // },
          {
            id: 'background-bg',
            property: 'background',
            type: 'bg',
          },
        ],
      },
      {
        name: 'Border',
        open: false,
        buildProps: [
          'border',
          'border-top',
          'border-left',
          'border-bottom',
          'border-right',
          'border-radius-c',
          'border-radius',
        ],
        properties: [
          {
            name: 'Border (All Sides)',
            property: 'border',
            type: 'composite',
            properties: [
              {
                name: 'Width',
                type: 'integer',
                units: ['px', 'em', 'rem'],
                property: 'border-width',
              },
              {
                name: 'Style',
                type: 'select',
                property: 'border-style',
                options: [
                  { value: 'none' },
                  { value: 'solid' },
                  { value: 'dotted' },
                  { value: 'dashed' },
                  { value: 'double' },
                  { value: 'groove' },
                  { value: 'ridge' },
                  { value: 'inset' },
                  { value: 'outset' },
                ],
              },
              {
                name: 'Color',
                type: 'color',
                property: 'border-color',
              },
            ],
          },
          {
            name: 'Border Top',
            property: 'border-top',
            type: 'composite',
            properties: [
              {
                name: 'Width',
                type: 'integer',
                units: ['px', 'em', 'rem'],
                property: 'border-right-width',
              },
              {
                name: 'Style',
                type: 'select',
                property: 'border-right-style',
                options: [
                  { value: 'none' },
                  { value: 'solid' },
                  { value: 'dotted' },
                  { value: 'dashed' },
                  { value: 'double' },
                  { value: 'groove' },
                  { value: 'ridge' },
                  { value: 'inset' },
                  { value: 'outset' },
                ],
              },
              {
                name: 'Color',
                type: 'color',
                property: 'border-right-color',
              },
            ],
          },
          {
            name: 'Border Left',
            property: 'border-left',
            type: 'composite',
            properties: [
              {
                name: 'Width',
                type: 'integer',
                units: ['px', 'em', 'rem'],
                property: 'border-right-width',
              },
              {
                name: 'Style',
                type: 'select',
                property: 'border-right-style',
                options: [
                  { value: 'none' },
                  { value: 'solid' },
                  { value: 'dotted' },
                  { value: 'dashed' },
                  { value: 'double' },
                  { value: 'groove' },
                  { value: 'ridge' },
                  { value: 'inset' },
                  { value: 'outset' },
                ],
              },
              {
                name: 'Color',
                type: 'color',
                property: 'border-right-color',
              },
            ],
          },
          {
            name: 'Border Bottom',
            property: 'border-bottom',
            type: 'composite',
            properties: [
              {
                name: 'Width',
                type: 'integer',
                units: ['px', 'em', 'rem'],
                property: 'border-right-width',
              },
              {
                name: 'Style',
                type: 'select',
                property: 'border-right-style',
                options: [
                  { value: 'none' },
                  { value: 'solid' },
                  { value: 'dotted' },
                  { value: 'dashed' },
                  { value: 'double' },
                  { value: 'groove' },
                  { value: 'ridge' },
                  { value: 'inset' },
                  { value: 'outset' },
                ],
              },
              {
                name: 'Color',
                type: 'color',
                property: 'border-right-color',
              },
            ],
          },
          {
            name: 'Border Right',
            property: 'border-right',
            type: 'composite',
            properties: [
              {
                name: 'Width',
                type: 'integer',
                units: ['px', 'em', 'rem'],
                property: 'border-right-width',
              },
              {
                name: 'Style',
                type: 'select',
                property: 'border-right-style',
                options: [
                  { value: 'none' },
                  { value: 'solid' },
                  { value: 'dotted' },
                  { value: 'dashed' },
                  { value: 'double' },
                  { value: 'groove' },
                  { value: 'ridge' },
                  { value: 'inset' },
                  { value: 'outset' },
                ],
              },
              {
                name: 'Color',
                type: 'color',
                property: 'border-right-color',
              },
            ],
          },
          {
            name: 'Border Radius',
            property: 'border-radius',
            properties: [
              { name: 'Top Left', property: 'border-top-left-radius' },
              { name: 'Top Right', property: 'border-top-right-radius' },
              { name: 'Bottom Left', property: 'border-bottom-left-radius' },
              { name: 'Bottom Right', property: 'border-bottom-right-radius' },
            ],
          },
        ],
      },
      {
        name: 'Animation',
        open: false,
        buildProps: ['animation'],
        properties: [
          {
            name: 'Animation',
            property: 'animation',
            type: 'composite',
            properties: [
              {
                name: 'Style',
                type: 'select',
                property: 'animation',
                options: [
                  { name: 'None', value: '' },
                  { name: 'Bounce', value: 'bounce' },
                  { name: 'Flash', value: 'flash' },
                  { name: 'Pulse', value: 'pulse' },
                  { name: 'Rubber Band', value: 'rubberBand' },
                  { name: 'Shake X', value: 'shakeX' },
                  { name: 'Shake Y', value: 'shakeY' },
                  { name: 'Head Shake', value: 'headShake' },
                  { name: 'Swing', value: 'swing' },
                  { name: 'Tada', value: 'tada' },
                  { name: 'Wobble', value: 'wobble' },
                  { name: 'Jello', value: 'jello' },
                  { name: 'Heart Beat', value: 'heartBeat' },
                  { name: 'Back In Down', value: 'backInDown' },
                  { name: 'Back In Left', value: 'backInLeft' },
                  { name: 'Back In Right', value: 'backInRight' },
                  { name: 'Back In Up', value: 'backInUp' },
                  { name: 'Back Out Down', value: 'backOutDown' },
                  { name: 'Back Out Left', value: 'backOutLeft' },
                  { name: 'Back Out Right', value: 'backOutRight' },
                  { name: 'Back Out Up', value: 'backOutUp' },
                  { name: 'Bounce In', value: 'bounceIn' },
                  { name: 'Bounce In Down', value: 'bounceInDown' },
                  { name: 'Bounce In Left', value: 'bounceInLeft' },
                  { name: 'Bounce In Right', value: 'bounceInRight' },
                  { name: 'Bounce In Up', value: 'bounceInUp' },
                  { name: 'Bounce Out', value: 'bounceOut' },
                  { name: 'Bounce Out Down', value: 'bounceOutDown' },
                  { name: 'Bounce Out Left', value: 'bounceOutLeft' },
                  { name: 'Bounce Out Right', value: 'bounceOutRight' },
                  { name: 'Bounce Out Up', value: 'bounceOutUp' },
                  { name: 'Fade In', value: 'fadeIn' },
                  { name: 'Fade In Down', value: 'fadeInDown' },
                  { name: 'Fade In Down Big', value: 'fadeInDownBig' },
                  { name: 'Fade In Left', value: 'fadeInLeft' },
                  { name: 'Fade In Left Big', value: 'fadeInLeftBig' },
                  { name: 'Fade In Right', value: 'fadeInRight' },
                  { name: 'Fade In Right Big', value: 'fadeInRightBig' },
                  { name: 'Fade In Up', value: 'fadeInUp' },
                  { name: 'Fade In Up Big', value: 'fadeInUpBig' },
                  { name: 'Fade In Top Left', value: 'fadeInTopLeft' },
                  { name: 'Fade In Top Right', value: 'fadeInTopRight' },
                  { name: 'Fade In Bottom Left', value: 'fadeInBottomLeft' },
                  { name: 'Fade In Bottom Right', value: 'fadeInBottomRight' },
                  { name: 'Fade Out', value: 'fadeOut' },
                  { name: 'Fade Out Down', value: 'fadeOutDown' },
                  { name: 'Fade Out Down Big', value: 'fadeOutDownBig' },
                  { name: 'Fade Out Left', value: 'fadeOutLeft' },
                  { name: 'Fade Out Left Big', value: 'fadeOutLeftBig' },
                  { name: 'Fade Out Right', value: 'fadeOutRight' },
                  { name: 'Fade Out Right Big', value: 'fadeOutRightBig' },
                  { name: 'Fade Out Up', value: 'fadeOutUp' },
                  { name: 'Fade Out Up Big', value: 'fadeOutUpBig' },
                  { name: 'Fade Out Top Left', value: 'fadeOutTopLeft' },
                  { name: 'Fade Out Top Right', value: 'fadeOutTopRight' },
                  { name: 'Fade Out Bottom Left', value: 'fadeOutBottomLeft' },
                  { name: 'Fade Out Bottom Right', value: 'fadeOutBottomRight' },
                  { name: 'Flip', value: 'flip' },
                  { name: 'Flip In X', value: 'flipInX' },
                  { name: 'Flip In Y', value: 'flipInY' },
                  { name: 'Flip Out X', value: 'flipOutX' },
                  { name: 'Flip Out Y', value: 'flipOutY' },
                  { name: 'Light Speed In Right', value: 'lightSpeedInRight' },
                  { name: 'Light Speed In Left', value: 'lightSpeedInLeft' },
                  { name: 'Light Speed Out Right', value: 'lightSpeedOutRight' },
                  { name: 'Light Speed Out Left', value: 'lightSpeedOutLeft' },
                  { name: 'Rotate In', value: 'rotateIn' },
                  { name: 'Rotate Out Down Left', value: 'rotateOutDownLeft' },
                  { name: 'Rotate Out Down Right', value: 'rotateOutDownRight' },
                  { name: 'Rotate Out Up Left', value: 'rotateOutUpLeft' },
                  { name: 'Rotate Out Up Right', value: 'rotateOutUpRight' },
                  { name: 'Hinge', value: 'hinge' },
                  { name: 'Jack In The Box', value: 'jackInTheBox' },
                  { name: 'Roll In', value: 'rollIn' },
                  { name: 'Roll Out', value: 'rollOut' },
                  { name: 'Zoom In', value: 'zoomIn' },
                  { name: 'Zoom In Down', value: 'zoomInDown' },
                  { name: 'Zoom In Left', value: 'zoomInLeft' },
                  { name: 'Zoom In Right', value: 'zoomInRight' },
                  { name: 'Zoom In Up', value: 'zoomInUp' },
                  { name: 'Zoom Out', value: 'zoomOut' },
                  { name: 'Zoom Out Down', value: 'zoomOutDown' },
                  { name: 'Zoom Out Left', value: 'zoomOutLeft' },
                  { name: 'Zoom Out Right', value: 'zoomOutRight' },
                  { name: 'Zoom Out Up', value: 'zoomOutUp' },
                  { name: 'Slide In Down', value: 'slideInDown' },
                  { name: 'Slide In Left', value: 'slideInLeft' },
                  { name: 'Slide In Right', value: 'slideInRight' },
                  { name: 'Slide In Up', value: 'slideInUp' },
                  { name: 'Slide Out Down', value: 'slideOutDown' },
                  { name: 'Slide Out Left', value: 'slideOutLeft' },
                  { name: 'Slide Out Right', value: 'slideOutRight' },
                  { name: 'Slide Out Up', value: 'slideOutUp' },
                ],
              },
              {
                name: 'Duration',
                type: 'integer',
                units: ['s', 'ms'],
                max: '',
                min: 1,
                property: 'animation-duration',
              },
              {
                name: 'Delay',
                type: 'integer',
                units: ['s', 'ms'],
                max: '',
                min: 0.1,
                property: 'animation-delay',
              },
              {
                name: 'Iteration',
                type: 'integer',
                max: '',
                min: 1,
                property: 'animation-iteration-count',
              },
            ],
          },
        ],
      },
      {
        name: 'Extra',
        open: false,
        buildProps: ['overflow', 'overflow-x', 'overflow-y', 'z-index', 'cursor'],
        properties: [],
      },
      {
        name: 'Flex',
        open: false,
        properties: [
          {
            name: 'Flex Container',
            property: 'display',
            type: 'select',
            defaults: 'block',
            list: [
              { value: 'block', name: 'Disable' },
              { value: 'flex', name: 'Enable' },
            ],
          },
          {
            name: 'Flex Parent',
            property: 'label-parent-flex',
            type: 'integer',
          },
          {
            name: 'Direction',
            property: 'flex-direction',
            type: 'radio',
            defaults: 'row',
            list: [
              {
                value: 'row',
                name: 'Row',
                className: 'icons-flex icon-dir-row',
                title: 'Row',
              },
              {
                value: 'row-reverse',
                name: 'Row reverse',
                className: 'icons-flex icon-dir-row-rev',
                title: 'Row reverse',
              },
              {
                value: 'column',
                name: 'Column',
                title: 'Column',
                className: 'icons-flex icon-dir-col',
              },
              {
                value: 'column-reverse',
                name: 'Column reverse',
                title: 'Column reverse',
                className: 'icons-flex icon-dir-col-rev',
              },
            ],
          },
          {
            name: 'Justify',
            property: 'justify-content',
            type: 'radio',
            defaults: 'flex-start',
            list: [
              {
                value: 'flex-start',
                className: 'icons-flex icon-just-start',
                title: 'Start',
              },
              {
                value: 'flex-end',
                title: 'End',
                className: 'icons-flex icon-just-end',
              },
              {
                value: 'space-between',
                title: 'Space between',
                className: 'icons-flex icon-just-sp-bet',
              },
              {
                value: 'space-around',
                title: 'Space around',
                className: 'icons-flex icon-just-sp-ar',
              },
              {
                value: 'center',
                title: 'Center',
                className: 'icons-flex icon-just-sp-cent',
              },
            ],
          },
          {
            name: 'Align',
            property: 'align-items',
            type: 'radio',
            defaults: 'center',
            list: [
              {
                value: 'flex-start',
                title: 'Start',
                className: 'icons-flex icon-al-start',
              },
              {
                value: 'flex-end',
                title: 'End',
                className: 'icons-flex icon-al-end',
              },
              {
                value: 'stretch',
                title: 'Stretch',
                className: 'icons-flex icon-al-str',
              },
              {
                value: 'center',
                title: 'Center',
                className: 'icons-flex icon-al-center',
              },
            ],
          },
          {
            name: 'Flex Children',
            property: 'label-parent-flex',
            type: 'integer',
          },
          {
            name: 'Order',
            property: 'order',
            type: 'integer',
            defaults: 0,
            min: 0,
          },
          {
            name: 'Flex',
            property: 'flex',
            type: 'composite',
            properties: [
              {
                name: 'Grow',
                property: 'flex-grow',
                type: 'integer',
                defaults: 0,
                min: 0,
              },
              {
                name: 'Shrink',
                property: 'flex-shrink',
                type: 'integer',
                defaults: 0,
                min: 0,
              },
              {
                name: 'Basis',
                property: 'flex-basis',
                type: 'integer',
                units: ['px', '%', ''],
                unit: '',
                defaults: 'auto',
              },
            ],
          },
          {
            name: 'Align',
            property: 'align-self',
            type: 'radio',
            defaults: 'auto',
            list: [
              {
                value: 'auto',
                name: 'Auto',
              },
              {
                value: 'flex-start',
                title: 'Start',
                className: 'icons-flex icon-al-start',
              },
              {
                value: 'flex-end',
                title: 'End',
                className: 'icons-flex icon-al-end',
              },
              {
                value: 'stretch',
                title: 'Stretch',
                className: 'icons-flex icon-al-str',
              },
              {
                value: 'center',
                title: 'Center',
                className: 'icons-flex icon-al-center',
              },
            ],
          },
        ],
      },
    ],
  };
};
const defaultFonts = [
  {
    name: 'Default',
    value:
      '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
  },
  {
    name: 'Arial',
    style: 'font-family: Arial, Helvetica, sans-serif; font-size:0.8rem',
    value: 'Arial, Helvetica, sans-serif',
  },
  {
    name: 'Arial Black',
    style: 'font-family: Arial Black, Gadget, sans-serif; font-size:0.8rem',
    value: 'Arial Black, Gadget, sans-serif',
  },
  {
    name: 'Helvetica',
    style: 'font-family: Helvetica, sans-serif; font-size:0.8rem',
    value: 'Helvetica, sans-serif',
  },
  {
    name: 'Impact',
    style: 'font-family: Impact, Charcoal, sans-serif; font-size:0.8rem',
    value: 'Impact, Charcoal, sans-serif',
  },
  {
    name: 'Lucida Sans Unicode',
    style: 'font-family: Lucida Sans Unicode, Lucida Grande, sans-serif; font-size:0.8rem',
    value: 'Lucida Sans Unicode, Lucida Grande, sans-serif',
  },
  {
    name: 'Tahoma',
    style: 'font-family: Tahoma, Geneva, sans-serif; font-size:0.8rem',
    value: 'Tahoma, Geneva, sans-serif',
  },
  {
    name: 'Times New Roman',
    style: 'font-family: Times New Roman, Times, serif; font-size:0.8rem',
    value: 'Times New Roman, Times, serif',
  },
  {
    name: 'Trebuchet MS',
    style: 'font-family: Trebuchet MS, Helvetica, sans-serif; font-size:0.8rem',
    value: 'Trebuchet MS, Helvetica, sans-serif',
  },
  {
    name: 'Verdana',
    style: 'font-family: Verdana, Geneva, sans-serif; font-size:0.8rem',
    value: 'Verdana, Geneva, sans-serif',
  },
];
const generateFontList = (project) => {
  const { customFonts = [] } = project;
  const uniqueFontFamilies = new Set();

  const customFontObjects = customFonts.reduce((acc, font) => {
    if (!uniqueFontFamilies.has(font.family)) {
      uniqueFontFamilies.add(font.family);

      acc.push({
        name: font.family,
        style: `font-family: ${font.family}; font-weight: 400; font-style: normal; font-size: 0.8rem;`,
        value: `${font.family}, sans-serif`,
      });
    }
    return acc;
  }, []);

  const fontList = [...defaultFonts, ...customFontObjects];
  return fontList;
};
